import { axios, axiosHelper } from '@/axios';

export const messagesService = {
    fetchPushNotifications
};

function fetchPushNotifications(userId, limit, offset) {
    return axios.post('/api/fetchPushNotifications', {
      userId: userId,
      limit: 20,
      offset: 0
    })
      .then(axiosHelper.handleResponse)
      .then(response => {
        return response.Result;
      });
  }
